import { render } from "./uploadNew.vue?vue&type=template&id=e87d6118&scoped=true"
import script from "./uploadNew.vue?vue&type=script&lang=js"
export * from "./uploadNew.vue?vue&type=script&lang=js"

import "./uploadNew.vue?vue&type=style&index=0&id=e87d6118&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e87d6118"]])

export default __exports__